import axios from "axios";
import { DateTime } from "luxon";

export default {
  async createAll(formData) {
    return axios.post(`/holidays`, formData);
  },
  async findOne({ id }) {
    return axios.get(`/holidays/${id}`);
  },
  async findAll() {
    return axios.get(`/holidays`);
  },
  async findBetweenRange(formData) {
    return axios.get(`/holidays/range/?start=${DateTime.fromJSDate(formData.startDate).toHTTP()}&end=${DateTime.fromJSDate(formData.endDate).toHTTP()}`);
  },
  async delete({ id }) {
    return axios.delete(`/holidays/${id}`);
  },
  async downloadByYear({year}) {
    return axios.get(`/holidays/download/${year}`);
  }
};
